import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var GrasaService = /** @class */ (function () {
    function GrasaService(http) {
        this.http = http;
        this.cargadoGrasa = true;
        this.grasa = [];
        this.grasaRFL = [];
        this.grasaRFC = [];
        this.grasaRFP = [];
        this.grasaRCL = [];
        this.grasaRCC = [];
        this.grasaRCP = [];
        this.cargarGrasa();
    }
    GrasaService.prototype.cargarGrasa = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.http.get('assets/data/dataLineas.json')
                .subscribe(function (resp) {
                _this.grasa = resp;
                _this.grasaRFL = _this.grasa[4].rutinafacial.limpieza;
                _this.grasaRFC = _this.grasa[4].rutinafacial.cuidado;
                _this.grasaRFP = _this.grasa[4].rutinafacial.proteccion;
                _this.grasaRCL = _this.grasa[4].rutinacorporal.limpieza;
                _this.grasaRCC = _this.grasa[4].rutinacorporal.cuidado;
                _this.grasaRCP = _this.grasa[4].rutinacorporal.proteccion;
                setTimeout(function () {
                    _this.cargadoGrasa = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    };
    GrasaService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    GrasaService = tslib_1.__decorate([
        Injectable({
            providedIn: 'root'
        })
    ], GrasaService);
    return GrasaService;
}());
export { GrasaService };
//# sourceMappingURL=grasa.service.js.map